module.exports = __webpack_public_path__ + "static/media/CatelogMt.2c414bf9.svg";